import { getClassLevel, normalizeClassId } from './classIdentity.mjs';
import { getSkillTraining } from './abilityChecks.mjs';
import { isRageEffective } from './barbarianRage.mjs';
export const PRIMAL_PROFICIENCIES = ['animalHandling','athletics','intimidation','nature','perception','survival'];
export const PRIMAL_CHECKS = ['acrobatics','intimidation','perception','stealth','survival'];
export function primalKnowledgeProfile(character = {}) {
  const raw = character.classState?.barbarian?.primalKnowledge?.skill;
  const skill = PRIMAL_PROFICIENCIES.includes(raw) ? raw : null;
  return { eligible: getClassLevel(character,'barbarian') >= 3, skill,
    available: PRIMAL_PROFICIENCIES.filter(key => !getSkillTraining(character,key).proficient) };
}
export const canUsePrimalStrength = (character, skill, combat = {}) =>
  getClassLevel(character,'barbarian') >= 3 && PRIMAL_CHECKS.includes(String(skill).toLowerCase()) && isRageEffective(character,combat);
export const barbarianOccupationIndex = character => (character.occupation || []).findIndex(entry =>
  normalizeClassId(entry.class ?? entry.Occupation ?? entry.Name ?? entry.occupation ?? entry.name) === 'barbarian');
